import React from "react";
import { IEmployeeAttendanceProps } from "../attendance.types";
import EmployeeAttendanceList from "./components/employee-attendance-list";
import EmployeeAttendanceCalendar from "./components/employee-attendance-calendar";
import "../../../styles/component/attendance.scss";


const EmployeeAttendance: React.FC<IEmployeeAttendanceProps> = ({employeeId, view}) => {

    return (
        <div className={'employee-attendance'}>
            {view === 'list' ?
                <EmployeeAttendanceList employeeId={employeeId}/>
                : (
                    <EmployeeAttendanceCalendar employeeId={employeeId}/>
                )}
        </div>
    )
}

export default EmployeeAttendance;
